export default {
  pageTitleNewApply: '新建备货申请单',
  platformName: '平台名称',
  storeName: '店铺名称',
  defaultState: '正常',
  state: '状态',
  shippingMethod: '头程段物流方式',
  selfDelivery: '跨境卖家自己负责',
  selfDelivery2: '跨境卖家自寄',
  noHeadTrip: '本地卖家自己负责',
  noHeadTrip2: '本地卖家自寄',
  menuTitleMyApply: '管理备货申请单',
  menuTitleStockUpList: '管理备货箱单',
  selectAuthorizedStore: '选择授权的店铺',
  operate: '操作',
  select: '选择',
  search: '查 询',
  productName: '商品名称',
  marketplaceSKU: '前台 SKU',
  warehouseSKU: '仓库货号',
  warehouseSKUId: '仓库货号',
  sourceProductID: '源货号',
  productList: '候选商品列表',
  restockProductList: '备货商品列表',
  marketplaceSkuNumber: '前台货号',
  productImage: '商品图片',
  variant: '商品规格',
  inventory: '库存',
  restockQty: '备货件数',
  restockingQty: '备货件数',
  usePlatformLogistics: '使用平台头程物流服务',
  total: '共',
  rows: '条',
  goTo: '跳至',
  submit: '提交申请',
  filingTime: '建档时间',
  pleaseSelectWarehouse: '请选择备货仓库',
  enterNumberCommas: '请在此处输入货号，多个以英文逗号分隔',
  warehouseSkuNumber: '仓库 SKU 编号',
  spec: '规格',
  warehouseNumber: '仓库编号',
  productCheck2: '备货Qty为空或填写格式不正确，请检查！',
  present: '提示',
  presentText: '检测到有同源货号商品在仓库备货，是否作为同一商品处理？',
  yes: '是',
  no: '否',
  pleaseSelectProduct: '请选择备货商品',
  productCheck1: '商品',
  handleSuccess: '操作成功',
  handleError: '操作失败',
  inputText: '输入值为：',
  restockingWarehouse: '备货仓库',
  applicationType: '备货类型',
  localApplication: '本地发起',
  chinaApplication: '中国发起',
  all: '所有',
  selectApplicationDate: '选择申请日期',
  applicationStatus: '申请状态',
  inReview: '待审核',
  approved: '已通过',
  fullyApproved: '全部通过',
  partiallyApproved: '部分通过',
  rejected: '已拒绝',
  applicationID: '申请单ID',
  warehouseCountry: '仓库所在国',
  warehouseCIty: '仓库所在城市',
  varietiesOfSKU: '货种数',
  applicationStatus2: '申请单状态',
  applicationTime: '申请时间',
  auditTime: '审核时间',
  applicant: '申请人',
  auditor: '审核人',
  details: '详情',
  restockApplyDetail: '备货申请单详情',
  logisticsAccount: '物流系统账号',
  appliedRestockQty: '备货申请件数',
  pendingOrderQty: '待下单件数',
  orderQty: '装箱数量',
  cancelApplication: '取消申请',
  placeRestockingOrder: '创建备货订单',
  placedRestockingOrders: '已创建备货订单',
  restockingOrderID: '备货箱单ID',
  warehouseName: '仓库名',
  restockingOrderQty1: '已装箱件数',
  restockingOrderQty2: '货件数',
  orderStatus: '箱单状态',
  restockStatus: '备货状态',
  effectiveTime: '生效时间',
  platformWaybill: '平台物流单号(箱号)',
  firstMileCargo: '国内快递',
  firstMileCargoWaybill: '国内快递单号',
  areYouSureRestockOrder: '您确定按当前填写的件数进行下单吗？',
  cancel: '取消',
  confirm: '确定',
  restockApplyOrderID: '备货申请单ID',
  myRestock: '备货箱单详情',
  printSheet: '打印箱单详情',
  confirmCancel: '您确定要取消吗',
  applyCancel: '取消备货箱单',
  cancelApply: '取消申请',
  createRestock: '创建备货箱单',
  shipmentThreeLogistics: '已委托三方国际物流商发货',
  localLogistics: '本地发货',
  trackNumberRemarks: '快递单号或备注',
  firstMileCargoMsg: '国内快递信息',
  pleaseLogisticsCompanies: '请选择物流公司',
  enterLogisticsNumber: '请输入国内快递单号',
  startShipment: '开始发货',
  historyStockOrders: '已创建备货箱单',
  nameInPartner: '店铺',
  enterRestockQty: '请填入当前备货qty',
  stockUspFailed: '创建失败！请补充店铺发货地址。点击此处跳转至地址补充界面',
  selectStore: '请选择店铺',
  enterSkuId: '请输入 SKU ID',
  selectStoreAndEnter: '请先选择店铺再输入',
  searchText: '搜 索',
  exportText: '导 出',
  exportList: '导出列表',
  exportDetail: '导出明细',
  selectProductsToExportDetail: '请先勾选要导出明细的 SKU',
  pendingDispatch: '待发货',
  pendingTransit: '中转仓待收件',
  pendingReceived: '中转仓已收件',
  shippedTransit: '中转仓已发出',
  ionFirstLegTransit: '头程运输中',
  clearingCustoms: '清关中',
  pendingRestockingReceipt: '待备货仓接件',
  pendingInventory: '待入库',
  shipped: '已发货',
  canceled: '已取消',
  completed: '已完成',
  Abnormal: '问题件',
  selectEffectiveDate: '选择箱单生效日期',
  manageFbkInventory: '管理备货商品库存',
  addRestockingApplication: '新增备货申请',
  selectWarehouse: '选择仓库',
  warehouse: '仓库',
  pleaseSelect: '请选择',
  fillingDate: '建档日期',
  totalInventory: '总库存',
  availableInventory: '可售库存',
  unsellableInventory: '不可售库存',
  unsellableInventoryQuantity: '不可售库存数量',
  lockedInventory: '现有锁定库存',
  unsalableReturnedInventory: '不可售库存',
  inventoryLog: '库存日志',
  inventoryDetail: '库存明细',
  viewDetail: '查看库存日志',
  timeOfChange: '变化发生时间',
  logId: '日志 ID',
  inventoryAfterChange: '变化后库存',
  inventoryMovement: '库存变动',
  changeQty: '变化量',
  changeType: '变动类型',
  date: '日期',
  timestamp: '发生时间',
  orderNumber: '单号',
  remainingInventory: '剩余库存',
  startDateInclusive: '开始日期（含）',
  endDateInclusive: '结束日期（含）',
  lastThirtyDays: '最近 30 天',
  selectCompleteDateRange: '请选择完整的开始日期和结束日期',
  startDateCannotBeAfterEndDate: '开始日期不能晚于结束日期',
  dateRangeCannotExceed365Days: '查询时间范围不能超过365天',
  noInventoryDetailRecords: '暂无库存明细记录',
  dateApplyPlaceHolder: '选择申请日期',
  inventoryRange: '库存区间',
  estimatedDispatchingDate: '预计发货日期',
  inTransitInventory: '在途库存',
  inPlanInventory: '已计划库存',
  r30Sales: '最近30天销量',
  r90Sales: '最近90天销量',
  appliedQty: '申请备货数量',
  orderableQty: '待装箱数量',
  approvedQty: '批准备货数量',
  orderedQty: ' 已装箱件数',
  boxPackedPieceQty: '装箱件数',
  inboundQty: '入仓件数',
  actualDispatchingDate: '实际发货日期',
  estDispatchingDate: '预计发货日期',
  invitationName: '备货邀请标签',
  estimatedPlaceHolder: '选择预计发货日期',
  remove: '删除',
  add: '添加',
  added: '已添加',
  crossBoarderShippingType: '跨境物流方式',
  expectedArrivalRestockingWarehouse: '预计到达目标备货仓日期',
  notes: '备注',
  selectDate: '选择日期',
  batchDispatch: '批量发货',
  byAir: '空运',
  bySea: '海运',
  dispatchBatchID: '发货批次号(ASN)',
  application: '申请单编号',
  expectedArrivalDate: '预计到仓日期',
  noPendingDispatchBox: '您没有待发货的备货箱单，无法进行批量发货操作。',
  batchDispatchingTextOne: '你确认要将以下',
  batchDispatchingTextTwo: '个备货箱单进行批量发货吗？',
  batchDispatchingTextThree: '箱单ID',
  yesDispatchAllThem: '是的，将他们全部发货',
  noCancelBatchDispatch: '不，取消发货',
  alrightAware: '好的，我已知晓',
  fillCargoNameWaybillNumber: '可填写物流公司和运单信息',
  customCode: '海关编码',
  customCodeName: '海关商品名',
  customCodeNameCN: '中文品名',
  customCodeAttribute: '商品申报要素',
  customDeclared: '申报价值（人民币）',
  back: '返回',
  confirmContinue: '确认并继续发货',
  pleaseEnsureCustom: '请确保以上商品的海关信息均已全部填写',
  hsInfoEmptyCannotShip: 'hs-info 未返回商品信息，当前暂不支持发货',
  confirmCustomRelated: '确认备货商品海关申报相关信息',
  searchCustomsCode: '查询海关编码',
  sku: 'SKU',
  rejectReason: '拒绝原因',
  activeProducts: '是否已上架商品?',
  skuId: 'SKU ID',
  listingId: 'Listing ID',
  multipleIdsCanSeparating: '用逗号分隔可输入多个ID',
  existingFbkProducts: '是否已经是FBK商品?',
  resetAll: '重置',
  authorizedStore: '授权店铺',
  operation: '操作',
  inTransitInventoryTip: '在途库存指的是已经已经发货还未到仓的库存数',
  inPlanInventoryTip: '计划中库存指的是已经备货申请审核通过但还未发货的库存数',
  r30SalesTip: '最近30天的销售出库数量',
  r90SalesTip: '最近90天的销售出库数量',
  productSameWarehouseSkuBeen: '有相同仓库货号的商品已经添加进入待确认备货商品列表了。',
  productSameSourceBeen: '有相同源货号的商品已经添加进入待确认备货商品列表了。',
  someWarehouseOrSourceBatch: `您选中并提交的商品中，不允许有仓库货号或者源货号相同的商品，请检查后再提交。`,
  sourceProductRefersTip: `源货号是指卖家自己定义商品的货源编号。源货号相同的商品，平台仓库将视为同一种商品，分配相同的仓库货号，并对库存进行共享。如果交易平台有两个SKU的源货号相同，那么对应的仓库货号商品库存为0时，则交易平台的这两个SKU都将显示售罄。`,
  idAlreadyExistsInThisList: '该编号已经存在于本申请列表中。',
  warehouseSkuSharingReminder: '仓库货号共享提醒',
  theSourceProductFollowFbk: '您输入的源货号({0}) 与下列 FBK 产品相关联。',
  areYouSureShareInventory: '您确定要与他们共享库存吗？',
  shareInventory: '确认共享',
  submitToApply: '提交申请',
  duplicate: '复制',
  close: '关闭',
  closed: '已关闭',
  areYouSureToClose: '关闭备货申请后，您将无法从此申请中创建新的备货箱单。 您是否确认继续执行关闭？',
  yesContinueToClose: '是的，继续关闭',
  noClose: '不关闭',
  productInfo: '商品信息',
  batchOperation: '批量操作',
  dispatch: '发货',
  singleDispatchDialogTitle: '发货',
  batchDispatchDialogTitle: '批量发货',
  batchShipWarehouseMismatch: '所选箱单备货仓库不一致，请分开发运',
  batchShipOrderNoMismatch: '不同申请单下的箱单请分开发运',
  batchShipLogisticsMismatch: '所选箱单头程物流方式不一致，请单独发运',
  batchDispatchStatusInvalid: '所选箱单中存在非待发货箱单，请重新选择',
  batchShipInterfacePending: '批量发货接口待定，当前暂不可提交',
  batchShipOverLimit: '单次最多可批量发货 {0} 个箱单，请重新选择',
  batchShipMissingOrderInfo: '所选箱单存在订单信息缺失，请重新选择',
  batchShipMissingCustomerOrderNo: '所选箱单缺少备货申请单号，请重新选择',
  batchShipMissingDetailList: '所选箱单缺少商品明细信息，暂不支持批量发货',
  batchShipMissingSku: '箱号 {0} 缺少 SKU 信息，请核对后再试',
  shipSuccessTitle: '发运成功',
  shipFailedTitle: '发运失败',
  singleShipSuccessMessage: '发运成功。',
  singleShipFailedMessage: '发运失败。',
  batchShipFailedMessage: '批量发运失败。',
  batchShipSuccessMessage: '批量发运成功。',
  shipFailedTip: '发货失败，请重试！',
  batchShipPartialSuccess: '发货完成。成功: {success}, 失败: {failed}。失败箱单: {list}',
  batchShipResultTitle: '发货结果',
  pleaseEnsureSameRestockWarehouse: '请检查所有选中的备货箱单的目标备货仓库均相同。',
  areYouPerformDispatchRestockBox: '你确认要将以下 {0} 个备货箱单进行同一批次发货吗？',
  yourDispatchBatchId: '您本次发货批次号为',
  printLater: '稍后打印',
  printNow: '打印发货批次号',
  pleaseEnsureBoxApplicationType: '检查所有选中的备货箱单是同一种类型。',
  pleaseEnsureBoxLogistics: '检查所有选中的备货箱单是同一种头程物流方式',
  onceTheApplicationClosed: '一旦备货申请关闭:',
  oneYouCanNotCreate: '1) 你将',
  oneYouCanNotCreate2: '无法',
  oneYouCanNotCreate3: '在该申请下创建备货箱单;',
  twoQuantityRestored: '2) 申请的备货件数',
  twoQuantityRestored2: '不会',
  twoQuantityRestored3: '在原备货邀请计划中恢复。',
  areYouSureClose: '您是否还确认关闭该备货申请？',
  batchPrintBoxNo: '批量打印箱号',
  batchPrintWarehouseNo: '批量打印仓库货号',
  batchPrintBatchNumber: '批量打印批次号',
  batchPrintBoxDetail: '批量打印箱单详情',
  noInteraction: '无交互',
  pleaseSelectStockBox: '请选择箱单',
  copySuccess: '复制成功',
  copyFailed: '复制失败',
  copyNoContent: '暂无可复制内容',
  arrivalWarehouseAt: '到仓时间',
  batchCreateRestock: '批量创建箱单',
  batchCreateDialogTitle: '批量创建箱单',
  batchCreatePrototypeTip: '批量创建箱单接口暂未就绪，当前弹窗仅展示页面原型。',
  save: '保存',
  batchCreateSku: 'SKU',
  pendingBoxQuantity: '待装箱数量',
  quantityPerBox: '每箱数量',
  boxCount: '箱数',
  maxCreatableBoxes: '最多可建箱数',
  estimatedPackedQty: '预计装箱数量',
  remainingQtyAfterCreate: '创建后剩余数量',
  lastBoxQuantity: '最后一箱数量',
  selectBatchCreateSku: '请选择 SKU',
  noPendingBoxQuantity: '当前没有可批量创建箱单的商品。',
  inputQuantityPerBox: '请输入每箱数量',
  quantityPerBoxExceeded: '已超过待装箱数量',
  inputBoxCount: '请输入箱数',
  invalidBoxCount: '请调整每箱数量和箱数',
  boxCountExceeded: '该商品最多只能创建 {0} 个备货箱',
  batchCreateQuantityExceeded: '总数量不能超过待装箱数量',
  createStockTip: '装箱需要根据实际情况操作，如果实际装入2个纸箱，则需对应系统操作2次装箱。注：发货前如果装错了箱数可以取消重新操作装箱，如果点击发货后不可修改需重新申请。为避免与实际装箱数量不一致，请确认先计算体积及确认实际需装入几个纸箱，再在系统里操作装箱填写实际装入的商品数量。',
  dispatchInfo: '发货信息',
  inputTip: '请输入',
  stockBox: {
    listTitle: '管理备货箱单',
    detailTitle: '备货箱单详情',
    basicInfo: '基本信息',
    stockBoxId: '备货箱单ID',
    stockBoxNo: '箱号',
    batchNo: '批次号',
    restockingApplicationOrder: '备货申请单',
    applicationNo: '备货申请单号',
    restockStatus: '备货状态',
    status: '箱单状态',
    pieceQty: '件数',
    boxCount: '箱数',
    shippingTime: '发货时间',
    expectedArrivalDate: '预计到仓日期',
    dispatchBatchId: '发货批次号(ASN)',
    platformWaybill: '平台物流单号(箱号)',
    effectiveTime: '生效时间',
    firstMileCarrier: '国内快递',
    firstMileWaybill: '国内快递单号',
    editDomesticTracking: '修改',
    editDomesticTrackingTitle: '修改国内快递信息',
    domesticTrackingNoChange: '您还未修改单号',
    printDetail: '打印箱单详情',
    cancel: '取消备货箱单'
  },
  pendingShip: '待发货',
  pendingTransitHubReceive: '待中转仓收货',
  transitHubReceived: '中转仓已收货',
  pendingStockWhReceive: '待备货仓收货',
  pendingStockWhShelve: '待备货仓上架',
  goodsInTransit: '运输中',
  goodsPartCollected: '部分收货',
  goodsPartShelves: '部分上架',
  goodsCollected: '待上架',
  shelved: '已上架',
  cancelled: '已取消'
}
